export default "__VITE_ASSET__QPWXLYBD__"